module.exports = __webpack_public_path__ + "assets/164f950556574b0ffdab1e4918cdc2f8.png";